import api from '@api'
import { isLoggedIn } from '@utils/auth'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import {
  transformAnnouncement,
  transformAnnouncementForServer,
  transformAnnouncementForReadOnly,
} from '@data/announcement'
import {
  buildFlatQualificationStructure,
  // buildRelationalQualificationStructure,
} from '@data/qualification'
import { transformExportGridDataForServer } from '@data/report'

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export function getAnnouncementsApi(
  filterFactor,
  searchCriteria,
  limit,
  offset
) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  return api
    .post(
      '/announcement/search/byqual',
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notification: {
          error: {
            message: __rootT('error'),
          },
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformAnnouncement),
        total: data.totalCount,
      }
    })
}

export function createAnnouncementApi(data) {
  const requestData = transformAnnouncementForServer(data)
  return api
    .post('announcement', requestData, {
      message: __rootT('added_successfully', {
        resource: __rootTc('announcement'),
      }),
    })
    .then(transformAnnouncement)
}

export function removeAnnouncementApi(data) {
  return api.delete(`announcement/${data.id}`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('announcement'),
    }),
  })
}

export function updateAnnouncementApi(data) {
  const updateData = transformAnnouncementForServer(data)
  return api
    .patch(`announcement/${data.id}`, updateData, {
      message: __rootT('updated_successfully', {
        resource: __rootTc('announcement'),
      }),
    })
    .then(transformAnnouncement)
}

export function toggleEnableApi(id, data) {
  return api
    .patch(`/announcement/${id}`, data, {
      message: __rootT('updated_successfully', {
        resource: __rootTc('announcement'),
      }),
    })
    .then((data) => transformAnnouncement(data))
}

export function getAnnouncementForTechniciansApi(
  searchCriteria = {},
  limit,
  offset
) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  return api
    .post(
      '/users/announcement',
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformAnnouncementForReadOnly),
        total: data.totalCount,
      }
    })
}

export function getAnnouncementForRequesterApi(
  searchCriteria = {},
  limit,
  offset
) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  return api
    .post(
      `${isLoggedIn() ? '/cportal' : '/public'}/announcement`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformAnnouncementForReadOnly),
        total: data.totalCount,
      }
    })
}

export function getTenentAnnouncementNotificationApi() {
  return api.get('/users/tenant/announcement').then((data) => data.objectList)
}

export function exportDataApi(data) {
  const qualDetails = [...((data.qualification || {}).quals || [])]
  return api.post(
    '/analytics/export/griddata',
    {
      ...transformExportGridDataForServer(data),
      qualification: qualDetails.length
        ? buildFlatQualificationStructure(qualDetails)
        : undefined,
    },
    {
      message: __rootT('export_successfully', {
        resource: __rootTc(data.model),
      }),
    },
    {
      notification: {
        error: {
          message: __rootT('error'),
        },
      },
    }
  )
}
